import React from 'react'
import NotFound404 from '../login/NotFound404';

const NotFound = () => (
    <NotFound404/>
)

export default NotFound
